export default __webpack_public_path__ + "static/media/AppealVDTemplate.7a6c4101.xlsx";